import type { RelayMetadata } from '@/contexts/AppContext';

/**
 * App default relays. Used as the initial `relayMetadata` for new users and as
 * a fallback when the user has no NIP-65 relay list configured (e.g. during
 * nostrconnect handshakes before any user relays have been loaded).
 */
export const APP_RELAYS: RelayMetadata = {
  relays: [
    // Deep-history aggregators. These retain far more of an author's past notes
    // than any single small relay, which is critical for an archive that needs
    // to surface rare/old records. Read from all of them so paging + by-id
    // lookups have the widest possible coverage.
    { url: 'wss://relay.nostr.band/', read: true, write: false },
    { url: 'wss://relay.damus.io/', read: true, write: true },
    { url: 'wss://nos.lol/', read: true, write: true },
    { url: 'wss://nostr.wine/', read: true, write: false },
    { url: 'wss://purplepag.es/', read: true, write: false },
    { url: 'wss://relay.ditto.pub/', read: true, write: true },
    { url: 'wss://relay.dreamith.to/', read: true, write: true },
    { url: 'wss://relay.primal.net/', read: true, write: true },
  ],
  updatedAt: 0,
};

/**
 * Broad set of deep-history relays used ONLY for exact-id "pinned note"
 * lookups (see usePinnedNotes). This is intentionally wider than the feed's
 * read set and includes relays commonly listed in @911receipts notes' own
 * relay hints, maximising the chance of finding a rare/old record.
 */
export const PINNED_LOOKUP_RELAYS: string[] = [
  'wss://relay.nostr.band/',
  'wss://relay.damus.io/',
  'wss://nos.lol/',
  'wss://nostr.wine/',
  'wss://purplepag.es/',
  'wss://relay.primal.net/',
  'wss://relay.snort.social/',
  'wss://nostr.mom/',
  'wss://nostr.bitcoiner.social/',
  'wss://eden.nostr.land/',
  'wss://nostr.land/',
  'wss://hist.nostr.land/',
  'wss://atlas.nostr.land/',
  'wss://relay.siamstr.com/',
  'wss://rss.nos.social/',
  'wss://relay.ditto.pub/',
  'wss://relay.dreamith.to/',
];
